import { useI18n } from '../../../shared/i18n/I18nProvider';
import { ReadOnlyModal } from '../../../shared/ui/WorkspaceKit';
import { useNavigate } from 'react-router';
import { useWorkspace } from '../../stores';
import { InvoicesPage } from './InvoicesPage';

export function CreateInvoicePage() {
  const { t } = useI18n();
  const { prefix } = useWorkspace();
  const navigate = useNavigate();
  return <><InvoicesPage /><ReadOnlyModal feature={t('Tạo hóa đơn')} onClose={() => navigate(`${prefix}/invoices`, { replace: true })} /></>;
}
